import { createContext } from 'react';
export var NavigatorContext = createContext({});
